import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { categoryTitles } from 'constant';
import { capitalizeFirstLetter } from 'lib/utils';
import { generateBreadcrumbsStyles } from 'components/Breadcrumbs/BreadcrumbsStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

export function Breadcrumbs({ isCategory = false, sx = {} }) {
    const { category, article } = useParams();
    const categoryTitle = category && categoryTitles[category] ? categoryTitles[category] : category;
    const articleTitle = article ? article.replaceAll('_', ' ').replaceAll('-', ' ') : '';
    const theme = useTheme();
    const styles = useMemo(() => generateBreadcrumbsStyles(theme), [theme]);

    return (
        <Box sx={{ ...styles.wrapper, ...sx }}>
            <Link style={{ color: theme.palette.primary.main }} to="/">Home</Link>
            <Box sx={styles.caret}>{' > '}</Box>
            <Link style={{ color: theme.palette.primary.main }} to={`/${category}`}>{categoryTitle}</Link>
            {!isCategory && <Box sx={styles.caret}>{' > '}</Box>}
            {!isCategory && (
                <Link
                    style={{ color: theme.palette.primary.main }}
                    to={`/${category}/${article}`}
                >
                    {capitalizeFirstLetter(articleTitle)}
                </Link>
            )}
        </Box>
    );
}
